import { keyframes } from '@mui/system';
import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeInSx: SystemStyleObject<Theme> = {
  animation: `${fadeIn} 1s`,
};

export const flexColSx: SystemStyleObject<Theme> = {
  flexBasis: 0,
  flexGrow: 1,
  maxWidth: '100%',
};

export const dropdownMenuPaperSx: SystemStyleObject<Theme> = {
  mt: '6px',
  borderRadius: '4px',
  overflow: 'initial',
  minWidth: '200px',
  '& .MuiMenu-list': {
    p: '4px 0',
  },
};

export const viewSingleEntrySx: SystemStyleObject<Theme> = {
  '&:not(:last-child)': {
    pb: 1.25,
  },

  '& > .field__wrapper': {
    mb: 3.25,
  },

  '& .files-list__files': {
    mb: -0.75,
  },

  '& .files-list__photos': {
    mt: 0.5,
    mb: -1.25,
  },

  '& .removable-input .add-info-btn': {
    mt: 0.5,
    ml: { xs: 0, md: 2.5 },
    whiteSpace: 'nowrap',
    textOverflow: 'unset',
  },

  '& .bulleted-list-field': {
    my: 1.75,
  },
};

export const viewSingleEntryListSx: SystemStyleObject<Theme> = {
  '& .field__wrapper': {
    mb: 0.5,
  },

  '& .field__wrapper > .field-label': {
    fontSize: '16px',
    fontWeight: 600,
    color: 'inherit',
  },

  '& .field__wrapper ul, & .field__wrapper p': {
    m: 0,
    mt: 0.5,
  },
};

export const fieldWrapperSx: SystemStyleObject<Theme> = {
  '& > div': {
    flexGrow: 1,
    wordBreak: 'break-word',
  },
  '&.field__wrapper--column': {
    display: 'flex',
    flexDirection: 'column',
  },
  '& .field-label': {
    m: '0 0 6px 0',
    flexShrink: 0,
    color: 'text.secondary',
  },
  '&.list-field:last-child': {
    mb: 0,
  },
};
